// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RkhP","toggle":"styles_toggle__3PJzs","preview":"styles_preview__2XsgE"};